export default class Treeview {
    constructor(item = {}, transformedNames) {
        this.transformedNames = transformedNames
        this.payload = {...item}
        this.selected = this.selected || []
        this.treeview = this.treeview || this.buildTreeview(item)
    }

    buildTreeview(data, parent = {}){
        let branches = [];
        for (const [name, value] of Object.entries(data)) {
            let branch = {name, path: `${parent.path ? parent.path + '.':''}${name}`}
            if (this.transformedNames) {
                branch.name = this.transformName(branch.name)
            }
            if (typeof value === 'object') {
                branch.children = []
                branch.children = [...branch.children, ...this.buildTreeview(value, branch)]
            }else{
                // branch = {...branch, value};  
                if (value === true) {
                    this.selected = [...this.selected, branch.path]
                }
            }
            branches = [...branches, branch]
        }
            return branches;
    }


    getChildren(parent){
        let children = []
        if (parent.children) {
            parent.children.forEach(child => {
                children = [...children, ...this.getChildren(child)]
            })
        }else{
            children = [...children, parent] 
        }
        return children
    }

    updatePayloadValue(path, val){
        let parent = path.split('.')?.[0]
        if (parent && this.payload[parent]) {
            eval(`this.payload.${path} = ${val}`)
        }
    }

    transformName(name){
      let newNameParts = name.split('_')
      newNameParts = newNameParts.map(part => part.charAt(0).toUpperCase() + part.slice(1))
      return newNameParts.join(' ')
    }
    

}
